var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46114 0.191016C5.71584 0.445703 5.71584 0.858644 5.46114 1.11333L1.57452 5.00001L5.46114 8.88671C5.71584 9.14141 5.71584 9.55428 5.46114 9.80898C5.20644 10.0637 4.79357 10.0637 4.53888 9.80898L0.191016 5.46114C-0.0636719 5.20644 -0.0636719 4.79357 0.191016 4.53888L4.53888 0.191016C4.79357 -0.0636719 5.20644 -0.0636719 5.46114 0.191016Z",
    fill: "#4A4A68"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.125,
    y1: 5.125,
    x2: 10.125,
    y2: 5.125,
    stroke: "#4A4A68",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.f2b5ec489f87267296eb8c1941fd4d72.svg";
export { ForwardRef as ReactComponent };